import { guessMarketingLang } from '@/marketing/i18n/guess';
import { canonicalLang } from '@shared/config/i18n';

/**
 * The language the launcher opens in — the same answer the site itself will settle on.
 *
 * This runs before React does, and Chatwoot bakes the launcher copy at `run()` time,
 * so guessing late means an English launcher on a Dutch page. It used to guess with
 * its own rules, which was a fourth implementation of something the site already
 * decides — and it disagreed: `known()` accepted a base code whenever any live locale
 * shared it, so `fr-FR` resolved to `fr` while the router, finding no bare `fr`,
 * redirected to `/nl`. A French launcher on a Dutch page, from two answers to one
 * question.
 *
 * Now it asks the site: the path when it already carries a locale (through
 * `canonicalLang`, so retired prefixes resolve like everywhere else), and otherwise
 * exactly what the index redirect would choose. Chatwoot is handed the base code
 * because it does not know the regional ones. Every live marketing language is in
 * its own widget catalogue — checked against the shipped v4.10.0 image, which carries
 * 55 locales including lt, bg, no and ro — so the launcher is never silently English
 * on a page that is not.
 *
 * Its own module rather than a private of `index.ts` so the resolution order is
 * testable: importing the boot module drags the stylesheet and the boot latch with
 * it, neither of which belongs in a unit test of a pure decision.
 */
export function currentLang(): string {
  const fromPath = canonicalLang(window.location.pathname.split('/')[1]?.toLowerCase());
  const settled = fromPath ?? guessMarketingLang();
  return settled.split('-')[0];
}
